import { useState, useEffect, useRef, forwardRef } from 'react';
import { colors } from '../../constants';
import Switch from 'react-switch';

export const Check = forwardRef((props, ref) => {
  const { value, onChange, useSwitch, label, style, children, size, ...rest } = props;

  if (useSwitch) {
    const factor =
      {
        sm: 0.65,
        md: 0.85,
      }[size] || 1;
    const extra = {
      height: Math.round(28 * factor),
      width: Math.round(56 * factor),
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Switch
          {...extra}
          onColor={colors.primary}
          uncheckedIcon={false}
          checkedIcon={false}
          checked={value || false}
          onChange={() => {
            onChange(!value);
          }}
        />
        {children}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 5 }} onClick={() => onChange(!value)}>
      <input type="checkbox" checked={value || false} ref={ref} readOnly style={{ ...style }} />
      {children}
    </div>
  );
});
